// Dependencies
import { all, call, takeEvery, fork, put } from "@redux-saga/core/effects";

// Action Types
import {
    SEND_WELCOME_EMAIL_REQUEST
} from 'Redux/actionTypes';

// Actions
import {
    sendWelcomeEmailResult,
} from 'Redux/actions';

// Helpers
import { clientMutation } from 'Core/data/GraphQLApi';
import { endpoints } from 'Core/defaultValues';
import { ExceptionManager } from 'Core/logManager';

function* sendWelcomeEmail({ payload }) {
    try {
        const { sfAccountId, entityId, firtsName, email, username, password, masterUser } = payload
        let QUERY = `
            mutation sendWelcomeEmail ( $sfAccountId: String!, $entityId: Int!, $firstName: String, $email: String!, $username: String!, $password: String!, $masterUser: Boolean!) {
                result: sendWelcomeEmail (sfAccountId: $sfAccountId, entityId: $entityId, firstName: $firstName, email: $email, username: $username, password: $password, masterUser: $masterUser)
            }
        `;

        let data = yield call(
            clientMutation,
            QUERY,
            {
                sfAccountId,
                entityId,
                firtsName,
                email,
                username,
                password,
                masterUser
            },
            endpoints.GRAPHQL_GENERAL,
        );

        yield put(sendWelcomeEmailResult({ reset: data?.result }))

    } catch (exc) {
        yield put(sendWelcomeEmailResult({ reset: false }))
        ExceptionManager(exc, 'Modules/users/.components/sendWelcomeEmail/redux/saga', 'sendWelcomeEmail');
    }
}

function* watchMethods() {
    yield takeEvery(SEND_WELCOME_EMAIL_REQUEST, sendWelcomeEmail);
}

export default function* rootSaga() {
    yield all([fork(watchMethods)]);
}